import React, {useEffect} from "react";
import AOS from 'aos';
import graphicsDesignServices from "../Assets/Images/graphics-desining-services (1).gif";
import designService from "../Assets/Images/design-services-img.avif";
import printnPackage from "../Assets/Images/packaging-and-printing.avif";
import socialMedia from "../Assets/Images/social-media-graphics-img.avif";
import illustrationGraphics from '../Assets/Images/illustration-graphics-img.avif'
import motionGraphics from '../Assets/Images/motion-graphics-img.avif'
import brandIdentity from '../Assets/Images/brand-identity-img.avif'
import CTA from "./CTA";


function Services() {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <div>
      <section className="inner-head" data-aos="fade-up" data-aos-duration="2000">
        <div className="overlay1">
          <div className="container py-2">
            <div className="row d-flex justify-content-cente align-items-center">
              <div className="col-md-5 head-content">
                <div className="section-header mb-3">
                  <h6>Explore Our Services</h6>
                  <h2>Imaginative Designs, Tangible Impact</h2>
                </div>
                <p>
                  Experience boundless creativity with our graphic design
                  services. Where ideas flourish, we bring your vision to
                  vibrant life, ensuring a lasting impact.
                </p>
              </div>
              <div className="col-md-7">
                <img
                  src={graphicsDesignServices}
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="our-services mt-5" id="graph-service">
        <div className="container-fluid px-5">
          <div className="row justify-content-center align-items-center">
            <div className="col-md-4" data-aos="fade-right" data-aos-duration="2000">
              <div className="service-content">
                <img
                  src={designService}
                  alt="design-services"
                  className="img-fluid"
                />
                <h4>Design Services</h4>
                <p>
                  Transform your brand with our Design services. From
                  captivating logos to stunning visuals, we bring your unique
                  identity to life with creativity and precision.
                </p>
              </div>
            </div>
            <div className="col-md-4" data-aos="fade-up" data-aos-duration="2000">
              <div className="service-content">
                <h4>Print & Packaging</h4>
                <p>
                  Elevate your brand's presence with our Print and Packaging
                  services. From eye-catching packaging designs to high-quality
                  prints, we ensure your products make a lasting impression.
                </p>
                <img
                  src={printnPackage}
                  alt=""
                  className="img-fluid order-md-2 order-1 large-img"
                />
              </div>
            </div>
            <div className="col-md-4" data-aos="fade-left" data-aos-duration="2000">
              <div className="service-content">
                <img src={socialMedia} alt="" className="img-fluid large-img" />
                <h4>Social Media Graphics</h4>
                <p>
                  Stand out in the digital landscape with our Social Media
                  Graphics service. Our designs are crafted to captivate,
                  engage, and amplify your brand's presence across social
                  platforms.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="other-services py-4" style={{backgroundColor: '#f3f6fb'}}>
        <div className="container">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-md-3" data-aos="fade-right" data-aos-duration="2000">
              <div className="section-header">
                <h2>Other Related Services</h2>
              </div>
              <p>We take on an extremely wide range of print and Web creative assignments, for both B2B and B2C clients. Here is an overview of work we do on a regular basis:</p>
            </div>
            <div className="col-md-9" data-aos="fade-left" data-aos-duration="2000">
            <button className="services-button">Digital Newsletters</button>
            <button className="services-button">Infographics</button>
            <button className="services-button">Tradeshow Booths</button>
            <button className="services-button">Print Newsletters</button>
            <button className="services-button">Tradeshow Graphics</button>
            <button className="services-button">Business Cards</button>
            <button className="services-button">Company Bruchers</button>
            <button className="services-button">Letterheads</button>
            <button className="services-button">Corporate Folders</button>
            <button className="services-button">Print Catalogs</button>
            <button className="services-button">Print Magazines</button>
            <button className="services-button">Tagline Development </button>
            <button className="services-button">Slide Presentations</button>
            <button className="services-button">Office Signage</button>
            <button className="services-button">POP Design</button>
            <button className="services-button">Direct Mail</button>
            <button className="services-button">Primary Packaging Design</button>
            <button className="services-button">Print Ad Designs</button>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="logos p-4" style={{backgroundColor: '#f3f6fb'}}>
        <div className="container">
          <div className="row  d-flex justify-content-center align-items-center">
            <div className="col-md-12">
              <Slider {...settings} >
                <div>
                  <img src={doodhNagar} alt="doodh-nagar" className="img-fluid" />
                </div>
                <div>
                  <img src={greenLeaf} alt="green-leaf" className="img-fluid" />
                </div>
                <div>
                  <img src={bbqNight} alt="bbq-nights" className="img-fluid" />
                </div>
                <div>
                  <img src={doodhNagar} alt="doodh-nagar" className="img-fluid" />
                </div>
                <div>
                  <img src={doodhNagar} alt="doodh-nagar" className="img-fluid" />
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </section> */}
 <section className="motion-graphics py-4" data-aos="fade-up" data-aos-duration="2000">
        <div className="container">
          <div className="row d-flex justify-content-between">
            
            <div className="col-md-4">
              <img src={motionGraphics} alt="illustration-graphics" className="img-fluid" />
            </div>
            <div className="col-md-7">
              <div className="section-header">
                <h6>Dynamic Motions</h6>
                <h2>Bring Your Brand To Life With Our Motion Graphics</h2>
              </div>
              <p>Elevate your brand with our Motion Graphics services, where visual storytelling meets dynamic creativity. From animated logos to engaging promotional videos, we breathe life into your ideas, leaving a memorable imprint. Our skilled team combines innovation with seamless motion to deliver captivating visuals that resonate across digital platforms.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="illustration py-4" style={{backgroundColor: '#f3f6fb'}}>
        <div className="container">
          <div className="row d-flex justify-content-between">
            <div className="col-md-7" data-aos="fade-right" data-aos-duration="2000">
              <div className="section-header">
                <h6>Illustration Elegance</h6>
                <h2>Explore Our Illutration Services</h2>
              </div>
              <p>Step into a world of creativity with our Illustration services. Our skilled artists bring your ideas to life, crafting vibrant visuals that tell a unique story. From whimsical characters to intricate designs, each illustration is a masterpiece. Immerse your audience in captivating narratives that leave a lasting impression on your brand.</p>
            </div>
            <div className="col-md-4" data-aos="fade-left" data-aos-duration="2000">
              <img src={illustrationGraphics} alt="illustration-graphics" className="img-fluid" />
            </div>
          </div>
        </div>
      </section>

      <section className="brand-identity py-4" >
        <div className="container">
          <div className="row d-flex justify-content-between">
            
            <div className="col-md-4" data-aos="fade-right" data-aos-duration="2000">
              <img src={brandIdentity} alt="brand-identity" className="img-fluid" />
            </div>
            <div className="col-md-7" data-aos="fade-left" data-aos-duration="2000">
              <div className="section-header">
                <h6>Dynamic Motions</h6>
                <h2>Bring Your Brand To Life With Our Motion Graphics</h2>
              </div>
              <p>Elevate your brand with our Motion Graphics services, where visual storytelling meets dynamic creativity. From animated logos to engaging promotional videos, we breathe life into your ideas, leaving a memorable imprint. Our skilled team combines innovation with seamless motion to deliver captivating visuals that resonate across digital platforms.</p>
            </div>
          </div>
        </div>
      </section>

      <CTA />
    </div>
  );
}
export default Services;